import { useTranslation as useI18nextTranslation } from 'react-i18next';

/**
 * Custom hook for translations with type safety
 * Re-exports react-i18next's useTranslation with additional helper methods
 */
export const useTranslation = () => {
    const { t, i18n } = useI18nextTranslation();

    /**
     * Change the current language
     * @param lng - Language code (e.g., 'en', 'es', 'fr')
     */
    const changeLanguage = (lng: string) => {
        return i18n.changeLanguage(lng);
    };

    /**
     * Get the current language code
     */
    const currentLanguage = i18n.language;

    /**
     * Get all available languages
     */
    const availableLanguages = Object.keys(i18n.options.resources || {});

    return {
        t,
        i18n,
        changeLanguage,
        currentLanguage,
        availableLanguages,
    };
};

export default useTranslation;
